import { render, staticRenderFns } from "./CitationBenchmark.vue?vue&type=template&id=190d9f61&scoped=true&"
import script from "./CitationBenchmark.vue?vue&type=script&lang=js&"
export * from "./CitationBenchmark.vue?vue&type=script&lang=js&"
import style0 from "./CitationBenchmark.vue?vue&type=style&index=0&id=190d9f61&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d9f61",
  null
  
)

export default component.exports